export default "__VITE_ASSET__a7c136a3__"